import { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import {
  colorsFoundation,
  dimensions,
  typographyTokens,
} from "../theme/index.js";

const EnvironmentBanner = ({ short = false }) => {
  const app_env = import.meta.env.VITE_APP_ENV || "production";
  const app_env_name = import.meta.env.VITE_APP_ENV_NAME || "Produktiv";

  // Session-only dismissal — the banner reappears on reload (not persisted).
  const [dismissed, setDismissed] = useState(false);

  if (app_env === "production" || dismissed) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: colorsFoundation.status.negative[600],
        color: "white",
        textAlign: "center",
        padding: short ? dimensions["xl"] : "4px",
        width: "100%",
        height: short ? "auto" : "32px",
      }}
    >
      <Typography variant="subtitle2" component="p" sx={{ fontSize: "12px" }}>
        {short ? (
          <Box
            component="span"
            sx={{
              fontWeight: typographyTokens.weight.bold,
              fontSize: typographyTokens.size.sm,
            }}
          >
            {`${app_env_name}-Umgebung`}
          </Box>
        ) : (
          <>
            Sie arbeiten in der{" "}
            <Box
              component="span"
              sx={{
                fontWeight: typographyTokens.weight.bold,
                fontSize: typographyTokens.size.sm,
              }}
            >
              {`${app_env_name}-Umgebung`}
            </Box>
            . NICHT FÜR DEN PRODUKTIVEN EINSATZ.
          </>
        )}
      </Typography>
      {!short && (
        <IconButton
          aria-label="Hinweis schließen"
          onClick={() => setDismissed(true)}
          size="small"
          sx={{
            position: "absolute",
            right: "4px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "white",
            padding: "2px",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
          }}
        >
          <CloseIcon sx={{ fontSize: "16px" }} />
        </IconButton>
      )}
    </Box>
  );
};

EnvironmentBanner.propTypes = {
  short: PropTypes.bool,
};

export default EnvironmentBanner;
